export default __webpack_public_path__ + "static/powered-by-c5f6803d7a5aa15ce91513893f685e75.webp";